import { Users } from "lucide-react";
import type { INavItem } from "@/models/INavItem";
import { CustomerRoutes } from "./routes";
import { CustomerPermissions } from "./permissions";

export const customerNav: INavItem = {
  labelKey: "nav.customers",
  icon: Users,
  path: CustomerRoutes.LIST,
  permissions: [CustomerPermissions.READ],
};
